import { render, staticRenderFns } from "./uppy_contracts.vue?vue&type=template&id=ca509958&scoped=true"
import script from "./uppy_contracts.vue?vue&type=script&lang=js"
export * from "./uppy_contracts.vue?vue&type=script&lang=js"
import style0 from "./uppy_contracts.vue?vue&type=style&index=0&id=ca509958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca509958",
  null
  
)

export default component.exports